import { ContentSubmissionStage } from '../types/content-submissions';

export const instagramRegex = /^(?:https?:\/\/)?(?:www\.)?instagram\.com\/(?:p|reel|tv)\/[\w.-]+/;
export const youtubeRegex =
  /^(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:embed\/|v\/|watch\?v=|shorts\/)|youtu\.be\/)([\w-]{11})(?:\S+)?$/;
export const tiktokRegex = /^(?:https?:\/\/)?(?:www\.)?tiktok\.com\/(?:v|@[\w.-]+\/video)\/(\d+)/;

// Constants for media upload on content submission
export const MAX_IMAGES = 20;
export const MAX_IMAGE_SIZE = 5 * 1024 * 1024; // 5MB for images
export const MAX_VIDEO_SIZE = 150 * 1024 * 1024; // 150MB for videos

export const sidebarLinks: {
  id: number;
  logo: string;
  label: string;
  href: string;
  disabled: boolean;
}[] = [
  { id: 1, logo: '📊️', label: 'Dashboard', href: '/dashboard', disabled: false },
  { id: 2, logo: '📷', label: 'My Posts', href: '/dashboard/my-posts', disabled: false },
  { id: 3, logo: '📂', label: 'Resources', href: '/dashboard/resources', disabled: false },
  { id: 4, logo: '💿', label: 'Submissions', href: '/dashboard/submissions', disabled: false },
  { id: 5, logo: '💳', label: 'Payment History ', href: '/dashboard/payment-history', disabled: false },
  { id: 6, logo: '🤳', label: 'Usage Rights ', href: '/dashboard/usage-rights', disabled: false },
];

export const TABS = {
  PENDING: {
    value: 'pending' as ContentSubmissionStage,
    label: 'Pending Review',
    emptyState: {
      title: 'No Submissions Yet!',
      description: 'Upload your content here to get feedback and approval from the brand.',
      showUploadButton: true,
    },
  },
  CHANGES_REQUESTED: {
    value: 'changesRequested' as ContentSubmissionStage,
    label: 'Changes Requested',
    emptyState: {
      title: 'No Changes Requested!',
      description: 'Once the brand reviews your content, the requested changes will reflect here.',
      showUploadButton: false,
    },
  },
  APPROVED: {
    value: 'approved' as ContentSubmissionStage,
    label: 'Approved',
    emptyState: {
      title: 'No Content Approved Yet!',
      description: 'Once the brand approves your content, it will show up here.',
      showUploadButton: false,
    },
  },
};
